/* Venom Technology — official logo RED BREATHING NEON only.
 * Desktop + mobile header. No spiderweb, entrance or logo movement.
 * Keeps white wordmark crisp; creates a filtered red-only glow layer.
 */
(function(){
 "use strict";
 var ns="http://www.w3.org/2000/svg";
 var observer=null,scheduled=false;
 function elSvg(tag,parent,klass){
   var e=document.createElementNS(ns,tag);
   if(klass)e.setAttribute("class",klass);
   if(parent)parent.appendChild(e);
   return e
 }
 function filters(){
   if(document.getElementById("venom-red-only-neon"))return;
   var svg=elSvg("svg");
   svg.classList.add("venom-red-neon-defs");
   svg.setAttribute("aria-hidden","true");
   var defs=elSvg("defs",svg),filter=elSvg("filter",defs);
   filter.id="venom-red-only-neon";
   filter.setAttribute("x","-20%");filter.setAttribute("y","-20%");
   filter.setAttribute("width","140%");filter.setAttribute("height","140%");
   filter.setAttribute("color-interpolation-filters","sRGB");
   var matrix=elSvg("feColorMatrix",filter);
   matrix.setAttribute("type","matrix");
   // Luma-neutral white yields zero opacity. Red areas remain vivid.
   matrix.setAttribute("values","1 0 0 0 0  0 0 0 0 0  0 0 0 0 0  2 -1 -1 0 0");
   document.body.appendChild(svg)
 }
 function placeGlow(real,clone){
   if(!real||!clone||!real.parentElement)return;
   var parent=real.parentElement, ir=real.getBoundingClientRect(),pr=parent.getBoundingClientRect();
   if(ir.width<12||ir.height<9)return;
   if(window.getComputedStyle(parent).position==="static")parent.style.position="relative";
   // Layout boxes may be scaled by sticky-header transforms.
   var sx=parent.offsetWidth&&pr.width/parent.offsetWidth||1;
   var sy=parent.offsetHeight&&pr.height/parent.offsetHeight||1;
   clone.style.left=((ir.left-pr.left)/sx)+"px";
   clone.style.top=((ir.top-pr.top)/sy)+"px";
   clone.style.width=(ir.width/sx)+"px";
   clone.style.height=(ir.height/sy)+"px"
 }
 function addRedNeon(real){
   if(real.dataset.venomRedNeon==="1")return;
   if(!real.parentElement)return;
   real.dataset.venomRedNeon="1";
   var copy=document.createElement("img");
   copy.className="venom-red-neon-copy";
   copy.src=real.currentSrc||real.src;
   copy.alt="";
   copy.setAttribute("aria-hidden","true");
   copy.setAttribute("draggable","false");
   copy.decoding="async";
   copy.loading="eager";
   real.parentElement.appendChild(copy);
   placeGlow(real,copy);
   if(window.ResizeObserver){
     var ro=new ResizeObserver(function(){placeGlow(real,copy)});
     ro.observe(real)
   }
 }
 function initGlow(){
   if(!document.body)return;
   filters();
   var originals=document.querySelectorAll("#header img.venom-official-logo");
   for(var i=0;i<originals.length;i++)addRedNeon(originals[i]);
   if(!observer){
     var header=document.getElementById("header");
     if(header&&window.MutationObserver){
       observer=new MutationObserver(function(){
         if(scheduled)return;
         scheduled=true;
         window.requestAnimationFrame(function(){scheduled=false;initGlow()})
       });
       observer.observe(header,{childList:true,subtree:true})
     }
     window.addEventListener("resize",function(){
       document.querySelectorAll("#header img.venom-official-logo").forEach(function(img){
         var copy=img.parentElement&&img.parentElement.querySelector("img.venom-red-neon-copy");
         if(copy)placeGlow(img,copy)
       })
     },{passive:true})
   }
 }

 function boot(){initGlow()}
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot,{once:true});
 else boot();
})();
